import React, { memo } from "react";
import { array, string, func, object, bool } from "prop-types";

import style from "./style.module.scss";
import MetricBar from "./MetricBar";
import CompareStatus from "./CompareStatus";
import { formatDate, getUserName, isComparisonReady, isSameId } from "./utils";

export default memo(CompareOverview);

CompareOverview.propTypes = {
  comparisons: array,
  histories: array,
  activeKey: string,
  selectableKeys: array,
  onSelect: func,
  onViewHistory: func,
};

// Overall metrics of every comparison, side by side
// Clicking a selectable column switches the per-label table to it
function CompareOverview({
  comparisons,
  histories,
  activeKey,
  selectableKeys = [],
  onSelect,
  onViewHistory,
}) {
  return (
    <div
      className={style.overviewGrid}
      style={{ gridTemplateColumns: `repeat(${comparisons.length}, 1fr)` }}
    >
      {comparisons.map((comparison) => (
        <OverviewColumn
          key={comparison.key}
          comparison={comparison}
          groundTruth={histories.find((history) =>
            isSameId(history.historyId, comparison.groundTruthId)
          )}
          isActive={comparisons.length > 1 && comparison.key === activeKey}
          onSelect={
            selectableKeys.includes(comparison.key)
              ? () => onSelect(comparison.key)
              : undefined
          }
          onViewHistory={onViewHistory}
        />
      ))}
    </div>
  );
}

OverviewColumn.propTypes = {
  comparison: object,
  groundTruth: object,
  isActive: bool,
  onSelect: func,
  onViewHistory: func,
};

function OverviewColumn({
  comparison,
  groundTruth,
  isActive,
  onSelect,
  onViewHistory,
}) {
  const { overall } = comparison.result || {};

  return (
    <div
      className={`${style.overviewColumn} ${
        isActive ? style.overviewColumnActive : ""
      } ${onSelect ? style.overviewColumnSelectable : ""}`}
      onClick={onSelect}
      title={onSelect ? "Xem chi tiết theo label type" : undefined}
    >
      <div className={style.overviewTitle}>{comparison.title}</div>

      {groundTruth ? (
        <button
          type="button"
          className={style.linkButton}
          onClick={(e) => {
            // Don't also switch the per-label table
            e.stopPropagation();
            onViewHistory(groundTruth.historyId);
          }}
          title="Xem bản ground truth"
        >
          {getUserName(groundTruth)} ↗
        </button>
      ) : (
        <span className={style.overviewRef}>#{comparison.groundTruthId}</span>
      )}

      {isComparisonReady(comparison) ? (
        <>
          <div className={style.metrics}>
            <MetricBar
              label="Khớp"
              value={overall.matchPercentage}
              variant="match"
            />
            <MetricBar
              label="Thiếu"
              value={overall.missingPercentage}
              variant="missing"
            />
            <MetricBar
              label="Thừa"
              value={overall.redundantPercentage}
              variant="redundant"
            />
          </div>
          <span className={style.compareDate}>
            {formatDate(comparison.date)}
          </span>
        </>
      ) : (
        <CompareStatus status={comparison.status} />
      )}
    </div>
  );
}
